import React from 'react';
import { Check } from 'lucide-react';

const STEP_LABELS = ['Audience', 'Content', 'Launch'];

interface WizardStepsProps {
  currentStep: number;
  onStepClick: (step: number) => void;
}

export const WizardSteps: React.FC<WizardStepsProps> = props => {
  return (
    <ol className="flex items-center gap-4">
      {STEP_LABELS.map((x, i) => {
        const step = i + 1;
        const isDone = step < props.currentStep;
        const isCurrent = step === props.currentStep;
        return (
          <li key={x} className="flex items-center gap-2">
            <button
              type="button"
              onClick={() => props.onStepClick(step)}
              disabled={step > props.currentStep}
              className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium disabled:cursor-not-allowed ${
                isCurrent
                  ? 'bg-alps-primary text-white'
                  : isDone
                    ? 'bg-green-100 text-green-700'
                    : 'bg-gray-100 text-gray-400'
              }`}
            >
              {isDone ? <Check className="h-4 w-4" /> : step}
            </button>
            <span className={`text-sm ${isCurrent ? 'font-medium text-gray-900' : 'text-gray-500'}`}>
              {x}
            </span>
            {step < STEP_LABELS.length && <span className="h-px w-8 bg-gray-200" />}
          </li>
        );
      })}
    </ol>
  );
};
